import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from '../Extras.page';
import { SlidesModal } from './slides.modal';
import { SlidesForm } from './slides.form';

export const SlidesView = () => {
  const vm = extrasVM.useValue().slidesVM;

  return (
    <>
      {vm.mode === 'create' && (
        <SlidesModal
          uploads={vm.uploads}
          isOpen
          onCancel={(id) => vm.dispatch('RemoveUpload', id)}
          onRetry={(id) => vm.dispatch('RetryFile', id)}
          onChange={(f) => vm.dispatch('Create', f)}
          onClose={() => vm.dispatch('Cancel')}
        />
      )}
      <SideModal
        isOpen={vm.mode === 'edit' || vm.mode === 'reupload'}
        onClose={() => vm.dispatch('Cancel')}
        noSpacing
        testId="slides-form-modal"
      >
        <div style={{ padding: '24px 45px' }}>
          <SlidesForm />
        </div>
      </SideModal>

      {vm.mode === 'reupload' && (
        <SlidesModal
          onCancel={(id) => vm.dispatch('RemoveUpload', id)}
          onRetry={(id) => vm.dispatch('RetryFile', id)}
          uploads={vm.uploads}
          isOpen
          onChange={(f) => vm.dispatch('Reupload', f)}
          onClose={() => vm.dispatch('Cancel')}
        />
      )}
    </>
  );
};
